export default {
  footerLink: 'Cookie settings',
  consentModal: {
    title: 'We use cookies',
    description: 'We use a minimal set of cookies to keep the site running, plus optional analytics and advertising cookies — only with your consent.',
    acceptAllBtn: 'Accept all',
    acceptNecessaryBtn: 'Reject all',
    showPreferencesBtn: 'Manage preferences',
  },
  preferencesModal: {
    title: 'Cookie preferences',
    acceptAllBtn: 'Accept all',
    acceptNecessaryBtn: 'Reject all',
    savePreferencesBtn: 'Save preferences',
    closeIconLabel: 'Close',
    sections: [
      {
        title: 'Necessary',
        description: 'These cookies are required for the site to work and cannot be disabled.',
        linkedCategory: 'necessary',
      },
      {
        title: 'Analytics',
        description: 'Help us understand how the site is used so we can improve it.',
        linkedCategory: 'analytics',
      },
      {
        title: 'Advertising',
        description: 'Used to make ads more relevant. Only enabled with your consent.',
        linkedCategory: 'ads',
      },
    ],
  },
}
